import { render, staticRenderFns } from "./Aliyun.vue?vue&type=template&id=25355ee9"
import script from "./Aliyun.vue?vue&type=script&lang=js"
export * from "./Aliyun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports